import { useMemo } from "react";
import { DEFAULT_EVENT_URL } from "../data/constants";
import { parseRankingUrl } from "../data/parser";

type EventLoaderProps = {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  loading: boolean;
  stage: string;
  error: string;
  compact?: boolean;
};

export function EventLoader({
  value,
  onChange,
  onSubmit,
  loading,
  stage,
  error,
  compact = false,
}: EventLoaderProps) {
  const preview = useMemo(() => {
    try {
      return { result: parseRankingUrl(value), error: "" };
    } catch (reason) {
      return { result: null, error: reason instanceof Error ? reason.message : "網址格式不正確。" };
    }
  }, [value]);

  return (
    <div className={compact ? "event-loader event-loader--compact" : "event-loader"}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          if (!loading && preview.result) onSubmit();
        }}
      >
        <label htmlFor="event-url">TATTA 排行榜網址</label>
        <div className="event-loader__controls">
          <input
            id="event-url"
            type="url"
            inputMode="url"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            placeholder={DEFAULT_EVENT_URL}
            aria-describedby="url-hint"
          />
          <button className="button button--primary" type="submit" disabled={loading || !preview.result}>
            {loading ? "讀取中…" : compact ? "切換賽事" : "載入賽事"}
          </button>
        </div>
      </form>

      {!compact && (
        <div id="url-hint" className="event-loader__preview" aria-live="polite">
          {preview.result ? (
            <>
              <span><b>賽事 ID</b> {preview.result.raceId}</span>
              <span><b>資料類型</b> distance-challenge</span>
              <span className="tag tag--success">● 已支援</span>
            </>
          ) : (
            <span className="text-muted">{value ? preview.error : "貼上網址後會先在本機驗證，不會直接抓取任意網址。"}</span>
          )}
        </div>
      )}

      {loading && (
        <div className="loading-track" role="status">
          <span className="loading-track__bar" />
          <span>{stage}</span>
        </div>
      )}
      {error && <div className="notice notice--error" role="alert">{error}</div>}
    </div>
  );
}
